// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const moment = require('moment');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR } = require('constants/index');

const fetchAlertsRequest = () => ({
    type: actionTypes.RA_ALERTS_REQUEST,
});

const fetchAlertsSuccess = data => ({
    type: actionTypes.RA_ALERTS_SUCCESS,
    payload: {
        data: data.response,
    },
});

const fetchAlertsFailure = error => ({
    type: actionTypes.RA_ALERTS_FAILURE,
    payload: {
        data: error,
    },
});

const fetchAlerts = () => dispatch => {
    const requestData = {
        query: {
            category: 'ROBO',
            from: moment()
                .subtract(1, 'years')
                .format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR),
            to: moment().format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR),
        },
    };
    dispatch(fetchAlertsRequest());
    APIGet(
        dispatch,
        apiURLBuilder.getURL('requestUserNotifications'),
        requestData,
    )
        .then(response => {
            dispatch(fetchAlertsSuccess(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(fetchAlertsFailure(error));
            } else {
                throw error;
            }
        });
};
module.exports = {
    fetchAlerts,
};
